import { useEffect } from "react"
import { useSessionState } from "../../../../reactor/Web"
import { useCookieConsents } from "../../../../studio/client"

/**
 * Declares the global `tmt_offer_sid` function for TargetCircle.
 */
declare const tmt_offer_sid: string | undefined
declare const tmt_event_sid: string | undefined

/**
 * Hook to track a sale with TargetCircle. Just include the hook on the order confirmation page,
 * and the rest should be taken care of by the script. Documentation available at
 * https://targetcircle.com/blog/automatic-article/installing-first-party-tracking-v2/
 */
export function useTargetCircleSaleTracking(orderNumber?: string) {
    const cookieConsents = useCookieConsents()
    const [isReported, setIsReported] = useSessionState(`tmt-reported-${orderNumber}`, false)

    useEffect(() => {
        if (
            orderNumber &&
            !isReported &&
            cookieConsents.data?.consents?.marketing &&
            typeof document !== "undefined" &&
            // If this is not set (entrypoint script is not initialized), we won't report the sale.
            typeof tmt_offer_sid !== "undefined" &&
            typeof tmt_event_sid !== "undefined" &&
            // Avoid appending this script more than once.
            !document.querySelector(
                'script[src*="cdn.trackmytarget.com/tracking/s/checkout.min.js"]'
            )
        ) {
            const el = document.createElement("script")
            el.setAttribute("src", "https://cdn.trackmytarget.com/tracking/s/checkout.min.js")
            el.setAttribute("data-type", "sale")
            el.setAttribute("data-offer-sid", tmt_offer_sid)
            el.setAttribute("data-event-sid", tmt_event_sid)
            el.setAttribute("data-id", orderNumber)
            document.body.appendChild(el)
            setIsReported(true)
        }
    }, [cookieConsents.data?.consents?.marketing, orderNumber, isReported, setIsReported])
}
